let map = {
  mymap: '',
  style: '',
  themeUrl: wpurls.siteUrl,
  png: '',
  pngFocus: '',
  popUpContent: '',
  locations: (typeof mapJson !== 'undefined' && mapJson.length > 0) ? mapJson : '',
  refreshTrigger: [],
  markers: [],

  init: function () {
    if (typeof mapJson !== 'undefined' && mapJson.length > 0) {
      var notMobile = !L.Browser.mobile;
      map.mymap = L.map('leaflet-map', {
        doubleClickZoom: false,
        dragging: notMobile,
        scrollWheelZoom: false
      })
      // map.scrollWheelZoom.disable();

      if (document.querySelectorAll('body.single-programmes').length > 0) {
        map.mymap.scrollWheelZoom.disable();
      }

      setTimeout(function () {
        map.mymap.invalidateSize();
      }, 500);

      const mapStyles = ['Cartographie', 'Satellite'];
      const mapLayers = [];
      const layerParams = { subdomains: ['mt0', 'mt1', 'mt2', 'mt3'] };

      /**
       layers (lyrs=) parameter
          Hybrid (Satellite with labels): y;
          Cartographie: m;
          Satellite: s;
          Terrain: p;
      **/
      mapLayers[mapStyles[0]] = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', layerParams);
      mapLayers[mapStyles[1]] = L.tileLayer(`https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}`, layerParams);

      // Default layer
      mapLayers['Cartographie'].addTo(map.mymap);

      L.control.layers(mapLayers).addTo(map.mymap);

      const clusterGroup = L.markerClusterGroup({
        // Customize cluster options
        maxClusterRadius: 50, // Maximum radius a cluster will cover
        spiderfyOnMaxZoom: true,
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
      });
      map.mymap.addLayer(clusterGroup);

      const searchMarkerUnfocus = 'marker-v2.svg';
      const searchMarkerFocus = searchMarkerUnfocus;
      const iconSize = [21, 21];
      const iconAnchor = [10, 21];

      map.png = L.icon({
        iconUrl: `${map.themeUrl}/assets/lib/leaflet/${searchMarkerUnfocus}`,
        iconSize: iconSize,
        iconAnchor: iconAnchor
      });

      map.pngFocus = L.icon({
        iconUrl: `${map.themeUrl}/assets/lib/leaflet/${searchMarkerFocus}`,
        iconSize: iconSize,
        iconAnchor: iconAnchor
      });

      if (map.locations[0].isSingular) {
        map.png = L.icon({
          iconUrl: `${map.themeUrl}/assets/lib/leaflet/marker-blue.png`,
          iconSize: [47, 71],
          iconAnchor: [23.5, 71]
        });
      }

      let boundsArr = [];
      map.locations.forEach(location => {
        map.showOnMap(location, clusterGroup);
        if (!location.adress || !location.adress.latitude || !location.adress.longitude) {
          return; // Skip if latitude or longitude is not available
        }
        if (location.adress.latitude.length > 0 && location.adress.longitude.length > 0) {
          const lat = parseFloat(location.adress.latitude.toString().replace(',', '.'));
          const lng = parseFloat(location.adress.longitude.toString().replace(',', '.'));
          boundsArr.push([lat, lng, location.structurePrimary]);
        }

      });

      const programs = document.querySelectorAll('.program__card--v2');

      programs.forEach(function ($program) {
        const id = $program.dataset.id;

        $program.addEventListener('mouseover', (event) => {
          // set default icon on all markers
          /*map.mymap.eachLayer((layer) => {
            if (layer instanceof L.Marker) {
              layer.setIcon(map.png);
            }
          });*/

          const marker = map.markers[id];

            if (!map.mymap.hasLayer(marker)) {
            // Marker is clustered, find its cluster and add CSS class
            const cluster = clusterGroup.getVisibleParent(marker);
            if (cluster && cluster._icon) {
              cluster._icon.classList.add('cluster-hovered');
            }
            return; // Do nothing if marker is clustered
            }

          // replace marker icon with selected icon
          if (marker) {
            marker.setIcon(map.pngFocus);
            if (marker._icon) {
              marker._icon.style.zIndex = 1000;
            }
            const currentLocation = map.locations.find(location => location.id == id);
            const priceTxt = map.getHoverPopupContent(currentLocation);
            marker.unbindPopup();
            marker.bindPopup(priceTxt, { maxWidth: 122, closeButton: false }).openPopup();
          }
		});

        $program.addEventListener('mouseout', () => {
          const marker = map.markers[id];
          // set default icon on all markers
          map.mymap.eachLayer((layer) => {
            if (!map.mymap.hasLayer(marker)) {
              const cluster = clusterGroup.getVisibleParent(marker);
              if (cluster && cluster._icon) {
                cluster._icon.classList.remove('cluster-hovered');
              }
              return; // Do nothing if marker is clustered
            }
            if (layer instanceof L.Marker) {
              marker.setIcon(map.png);
              marker.closePopup();
            }
          });

		});
      });

      // Zoom map with all marker and zoom dynamic - mode 1
      // Zoom map with the first marker on center (= zoom par structure) - mode 2
      let mode = 2;
      if (boundsArr.length > 0) {
        if (map.locations[0].isSingular) {
          bounds = L.latLngBounds(boundsArr);
          map.mymap.fitBounds(bounds, {
            paddingTopLeft: [50, 50],
            paddingBottomRight: [50, 50],
          });
          map.mymap.setZoom(15);

        } else {
          var bounds = [];
          if (mode == 2) {
            var boundsFilter = boundsArr.filter(item => item[2] == true);
            if (boundsFilter.length > 0) {
              boundsArr = boundsFilter;
            }
          }

          if (boundsArr.length > 0) {
            bounds = L.latLngBounds(boundsArr);
            map.mymap.fitBounds(bounds, {
              paddingTopLeft: [100, 100],
              paddingBottomRight: [50, 50],
            });
          }
        }
      }


      map.refreshTrigger = [
        document.getElementById('full-map'),
        document.getElementById('no-map'),
        document.getElementById('partial-map')
      ];

      if (!map.locations[0].isSingular) {
        [...map.refreshTrigger].filter(el => el !== null).forEach(function (el) {
          el.addEventListener('click', () => {
            setTimeout(() => {
              map.mymap.invalidateSize();
            }, "400")
          })
        })
      }
    }
  },

  getHoverPopupContent: function (location) {
    let priceTxt = '';
    if (location.prix_masque == true || location.price == 0) {
      priceTxt = '<strong>Prix sur demande</strong>';
    } else {
      // transformer le prix sous la forme 250K au lieu de 250000
      const priceValue = parseFloat(location.price) || 0;
      const priceK = priceValue >= 1000 ? (priceValue / 1000).toFixed(1) : priceValue;
      priceTxt = 'Dès <strong>' + priceK + 'K</strong>';
    }
    return `<p class="marker--hover">${priceTxt}</p>`;
  },

  getClickPopupContent: function (location) {
    if (!location.img) {
      location.img = '';
    }

	var priceTxt = '';
    if (location.prix_masque == true || location.price == 0) {
      priceTxt = '<strong>Prix sur demande</strong>';
    } else {
      priceTxt = 'À partir de <strong>' + location.price + ' <span>€</span></strong>';
    }
    map.popUpContent = `
          <a href="${location.url}">
              <figure class="site-${location.provenance}">${location.img}</figure>
              <div class="popup-description">
                  <p class="card-title">${location.title}</p>
                  <p class="card-adress"><span class="ico" data-ico="pin"></span>${location.adress.ville} (${location.adress.code_postal.slice(0, 2)})</p>
                  <p class="card-street">${location.adress.rue}</p>
                  <p class="card-price">${priceTxt}</p>
              </div>
          </a>`;

    return map.popUpContent;
  },

  showOnMap: function (location, markers) {
    map.popUpContent = this.getClickPopupContent(location);
    const lat = parseFloat(location.adress.latitude.toString().replace(',', '.'));
    const lng = parseFloat(location.adress.longitude.toString().replace(',', '.'));
    if (isNaN(lat) || isNaN(lng)) {
      return; // Skip if coordinates are invalid
    }
    var newMarker = new L.Marker([lat, lng], {
      icon: map.png
    }).addTo(markers);

    // au sorvol, une popup affiche le prix
    newMarker.addEventListener('mouseover', (e) => {
      // Check if marker is inside a cluster
      if (markers.hasLayer(e.target) && markers.getVisibleParent(e.target) !== e.target) {
        return; // Do nothing if marker is clustered
      }

      e.target.setIcon(map.pngFocus);
      if (!map.locations[0].isSingular) {
        const priceTxt = map.getHoverPopupContent(location);
        e.target.unbindPopup();
        e.target.bindPopup(priceTxt, { maxWidth: 122, closeButton: false }).openPopup();
      }
        document.getElementById(target).classList.add('active');
    });


    newMarker.addEventListener('mouseout', (e) => {
      // Check if marker is inside a cluster
      if (markers.hasLayer(e.target) && markers.getVisibleParent(e.target) !== e.target) {
        return; // Do nothing if marker is clustered
      }

      e.target.setIcon(map.png);
      // Only close the popup if it was opened with closeButton: false (hover popup)
      const popup = e.target.getPopup();
      if (popup && popup.options.closeButton === false) {
        e.target.closePopup();
      }
    });

		map.markers[location.id] = newMarker;

		if (!map.locations[0].isSingular) {
      newMarker.addEventListener('click', (e) => {
        // Close all open popups before opening the new one
        map.mymap.eachLayer((layer) => {
          if (layer instanceof L.Marker && layer.getPopup()) {
            layer.closePopup();
            layer.setIcon(map.png);
          }
        });
        e.target.setIcon(map.pngFocus);

		e.target.unbindPopup();
        e.target.bindPopup(map.getClickPopupContent(location), { maxWidth: 300, autoClose: false }).openPopup();
      });

		newMarker.on('popupclose', () => {
        newMarker.setIcon(map.png);
      });

	}
  },
};

document.addEventListener('DOMContentLoaded', map.init);